__turbopack_context__.v({
  "preamble": "IntroSection-module__ilncmW__preamble",
  "root": "IntroSection-module__ilncmW__root",
  "title": "IntroSection-module__ilncmW__title",
});
